import React from 'react';
import {
  Button,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from 'dayjs';

import { georgianFontBase64 } from '../../assets/fonts/MyGeoFont';

const fieldLabels = {
  userType: 'მომხმარებლის ტიპი',
  productCategory: 'პროდუქტის კატეგორია',
  incidentDescription: 'ინციდენტის აღწერა',
  productRiskDate: 'როდის დაფიქსირდა პროდუქტის საფრთხე',
  productionDate: 'წარმოების თარიღი',
  productDescription: 'პროდუქტის აღწერა',
  city: 'ქალაქი',
  organization: 'ორგანიზაცია',
  // agree: 'მონიშნულია',
  productName: 'პროდუქტის დასახელება',
  brandName: 'ბრენდის დასახელება',
  firstName: 'განმცხადებლის სახელი',
  lastName: 'განმცხადებლის გვარი',
  email: 'განმცხადებლის ელ-ფოსტა',
  phone: 'განმცხადებლის ტელეფონი',
  address: 'განმცხადებლის მისამართი',
  selectedValue: 'პროდუქტის გამოყენებას დაზიანება მოჰყვა?',
  personAge: 'დაზარალებულის ასაკი',
  personFirstName: 'დაზარალებულის სახელი',
  personLastName: 'დაზარალებულის გვარი',
  personEmail: 'დაზარალებულის ელ-ფოსტა',
  personPhone: 'დაზარალებულის ტელეფონი',
  personAddress: 'დაზარალებულის მისამართი',
};

const step3Keys = [
  'personAge',
  'personFirstName',
  'personLastName',
  'personEmail',
  'personPhone',
  'personAddress',
];

const formatValue = (key, value, formData, filtersOptions) => {
  // Always show the radio answer as-is
  if (key === 'selectedValue') return value;
  if (key === 'productCategory') {
    const selectedCategory = filtersOptions?.categories?.find(
      (cat) => cat.value === value
    );
    return selectedCategory ? selectedCategory.label : value;
  }
  if (step3Keys.includes(key))
    return formData.selectedValue === 'კი' ? value || 'არ არის შევსებული' : '';
  if (value instanceof File) return value.name;
  if (dayjs.isDayjs(value)) return value.format('DD/MM/YYYY');
  return value || 'არ არის შევსებული';
};

const Step5 = ({ formData, filtersOptions }) => {
  const generatePDF = () => {
    // 1. Create a jsPDF instance
    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'a4',
    });

    doc.addFileToVFS('NotoSansGeorgian-Regular.ttf', georgianFontBase64);
    doc.addFont('NotoSansGeorgian-Regular.ttf', 'NotoSansGeo', 'normal');
    doc.setFont('NotoSansGeo', 'normal');

    doc.text('განაცხადის დეტალები', 14, 20);

    // 4. Build table data from your formData
    const tableData = Object.entries(formData).reduce((acc, [key, value]) => {
      const formatted = formatValue(key, value, formData, filtersOptions);
      if (step3Keys.includes(key) && formatted === '') return acc;
      acc.push([fieldLabels[key] || key, formatted]);
      return acc;
    }, []);

    autoTable(doc, {
      startY: 30,
      // head: [['ველი', 'შეყვანილი მონაცემი']],
      body: tableData,
      styles: {
        font: 'NotoSansGeo', // Use your Georgian font
        fontSize: 10,
        overflow: 'linebreak', // Wrap text onto new lines
      },
      headStyles: {
        font: 'NotoSansGeo',
        fillColor: [41, 128, 185], // Example header background (RGB)
        textColor: 255, // White text for header
      },
      bodyStyles: {
        font: 'NotoSansGeo',
      },
      columnStyles: {
        0: { cellWidth: 50, overflow: 'linebreak' },
        1: { cellWidth: 130, overflow: 'linebreak' },
      },
      didParseCell: function (data) {
        // Ensure every cell uses the Georgian font (especially header cells)
        data.cell.styles.font = 'NotoSansGeo';
      },
    });

    doc.save('application.pdf');
  };

  return (
    <Box>
      <Typography variant='h6'>შეყვანილი მონაცემები</Typography>
      <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>ველი</strong>
              </TableCell>
              <TableCell>
                <strong>შეყვანილი მონაცემი</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(formData).map(([key, value]) => {
              const formatted = formatValue(
                key,
                value,
                formData,
                filtersOptions
              );
              if (step3Keys.includes(key) && formatted === '') return null;
              return (
                <TableRow key={key}>
                  <TableCell>{fieldLabels[key] || key}</TableCell>
                  <TableCell>{formatted}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={2} display='flex' justifyContent='center'>
        <Button variant='contained' color='primary' onClick={generatePDF}>
          ჩამოტვირთვა PDF
        </Button>
      </Box>
    </Box>
  );
};

export default Step5;
